import "./GameOver.scss";
import { useMultiplayer } from "../../../context/MultiplayerContext";
import ChessButton from "../../visual/ChessButton/ChessButton";
import { getOpponent } from "../../../utils/utils";

export default function PlayAgainResponseModal() {
    const { multiplayerState, responseToPlayAgainRequest } = useMultiplayer();

    if (!multiplayerState.playAgainRequest.receivedRequest) return null;

    const opponent = getOpponent(multiplayerState);

    return (
        <div className="play-again-modal">
            <p>{`${opponent.username} wants to play again. Accept?`}</p>
            <ChessButton
                data-navrow={0}
                data-navcol={0}
                autoFocus
                onClick={() => responseToPlayAgainRequest("accept")}
            >
                Accept
            </ChessButton>
            <ChessButton
                data-navrow={1}
                data-navcol={0}
                onClick={() => responseToPlayAgainRequest("deny")}
            >
                Decline
            </ChessButton>
        </div>
    );
}
